import React from "react";
import "../HomeAgriculture.css";
import { NavLink } from "react-router-dom";
import agricultureImg from "../../assets/Kishan-Banner.png";

import {
    FiArrowRight,
    FiCheckCircle,
    FiShoppingCart,
    FiUsers,
    FiPackage,
    FiGrid,
    FiCreditCard,
    FiTruck,
} from "react-icons/fi";

const HomeAgriculture = () => {
    return (
        <section className="home-agriculture">

            <div className="container">

                <div className="agriculture-wrapper">

                    {/* Left Side */}

                    <div className="agriculture-image">

                        <img
                            src={agricultureImg}
                            alt="Agriculture Digital Solutions"
                        />

                    </div>

                    {/* Right Side */}

                    <div className="agriculture-content">

                        <span className="agriculture-badge">
                            🌱 Agriculture & Digital Innovation
                        </span>

                        <h2>
                            Empowering Farmers Through
                            <span> Digital Commerce</span>
                        </h2>

                        <p>
                            At <strong>Kishancart Digital (OPC) Private Limited</strong>,
                            we believe technology can transform agriculture by
                            connecting farmers, retailers, wholesalers, and
                            consumers through innovative digital platforms.
                            Our solutions simplify agricultural commerce,
                            improve market access, and help businesses manage
                            products, vendors, customers, and orders with ease.
                        </p>

                        <div className="agriculture-features">

                            <div className="feature-box">
                                <FiShoppingCart />
                                <span>Digital Agriculture Marketplace</span>
                            </div>

                            <div className="feature-box">
                                <FiUsers />
                                <span>Farmer & Vendor Management</span>
                            </div>

                            <div className="feature-box">
                                <FiPackage />
                                <span>Inventory & Order Management</span>
                            </div>

                            <div className="feature-box">
                                <FiGrid />
                                <span>Digital Product Catalog</span>
                            </div>

                            <div className="feature-box">
                                <FiCreditCard />
                                <span>Secure Payment Integration</span>
                            </div>

                            <div className="feature-box">
                                <FiTruck />
                                <span>Retail & Distribution Solutions</span>
                            </div>

                        </div>

                        <a
                            href="/agriculture"
                            className="agriculture-btn"
                        >
                            Explore Our Solutions
                            <FiArrowRight />
                        </a>

                    </div>

                </div>

            </div>

        </section>
    );
};

export default HomeAgriculture;